import { getSecureLocalItem } from "utils/secureSessionStorage";
import api from "./api";

const getAuthConfig = async () => {
  const token = getSecureLocalItem("token");
  return {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };
};

// Super Admin Login
export const superAdminLogin = async (credentials) => {
  return api.post("/v1/api/super-admin/login", credentials);
};

// Regular User/Tenant Login
export const regularUserLogin = async (credentials) => {
  return api.post("/v1/api/login", credentials);
};

// Registration , here no need token
export const register = async (userData) => {
  return api.post("v1/api/auth/register", userData);
};

// Fetch Active Companies for Employee by Phone
export const getEmployeeCompanies = async (phone) => {
  return api.post("/v1/api/auth/employee/companies", { phone });
};

// Employee Login
export const employeeAppLogin = async (credentials) => {
  return api.post("/v1/api/auth/loginForApp", credentials);
};

// Reset Employee Password
export const resetPassword = async (data) => {
  const config = await getAuthConfig();
  return api.put("/v1/api/auth/resetPassword", data, config);
};